// src/main.ts
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'nprogress/nprogress.css'
import './main.css'

import { useAuthStore } from '@/admin/stores/Auth/auth'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

const auth = useAuthStore(pinia)

// hydrate on boot
auth.initFromStorage?.().catch(() => {})

// Only logout on close / navigate-away, NOT on reload
window.addEventListener('pagehide', () => {
  // Works in modern browsers
  const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
  const isReload = nav?.type === 'reload'
  if (!isReload && auth.isAuthenticated) {
    auth.logoutKeepalive({ reason: 'close-or-navigate' })
  }
})

router.isReady().then(() => app.mount('#app'))
